import { initializeApp } from 'firebase/app';
import { getMessaging } from 'firebase/messaging';

// const firebaseConfig = {
//   apiKey: 'AIzaSyD1HqS9iXvz5S6xJ8qW7Xyf4kGv9c6WfGh5Q',
//   authDomain: 'schoolation-test.firebaseapp.com',
//   projectId: 'schoolation-test',
//   storageBucket: 'schoolation-test.appspot.com',
//   messagingSenderId: '102168889226',
//   appId: '1:102168889226:web:7a7d4c7f3e5f2f33b3d3ff',
// };

const firebaseConfig = {
  apiKey: "AIzaSyBlQmIEGJWdCSzmWI92AILxssmAII0LnDM",
  authDomain: "schoolation-test.firebaseapp.com",
  projectId: "schoolation-test",
  storageBucket: "schoolation-test.firebasestorage.app",
  messagingSenderId: "813515842961",
  appId: "1:813515842961:web:2b0f278504e8a5b2786630",
  measurementId: "G-FNZKW3FCS9"
};

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

export { firebaseApp, messaging };
